const cardStockId = {
	cardStock: {
		title: "Kartu Stok",
		subtitle: "Ringkasan daftar kartu stok",
		filter: {
			store: {
				placeholder: "Pilih Toko",
			},
			type: {
				placeholder: "Pilih Tipe",
			},
			date: {
				placeholder: "Pilih Tanggal",
			},
		},
		table: {
			title: "Data Kartu Stok",
			columns: {
				store: "Toko",
				category: "Kategori",
				type: "Tipe",
				product: "Produk",
				variant: "Varian",
				initial_stock: "Stok Awal",
				stock_in: "Stok Masuk",
				stock_out: "Stok Keluar",
				sales: "Penjualan",
				transfer_in: "Transfer Masuk",
				transfer_out: "Transfer Keluar",
				adjustment: "Penyesuaian",
				last_stock: "Stock Akhir",
				unit: "Satuan",
			},
		},
		forms: {
			export: {
				toast: {
					success: {
						title: "Berhasil",
						description: "Berhasil expor {rows} baris ke excell!",
					},
					failed: {
						title: "Failed",
						description: "Gagal expor data ke excell!",
					},
				},
			},
			delete: {
				title: "Hapus kartu stok",
				description: "Apakah anda yakin akan menghapus {name}?",
				toast: {
					success: {
						title: "Berhasil",
						description: "Berhasil menghapus!",
					},
					failed: {
						title: "Failed",
						description: "Gagal menghapus!",
					},
				},
			},
		},
		empty_state: {
			title: "Tidak ada data kartu stok",
			description: "Silakan tambahkan data kartu stok baru.",
		},
		actions: {
			save: "Simpan",
			save_changes: "Simpan Perubahan",
			saving_changes: "Menyimpan Perubahan...",
			saving: "Menyimpan...",
			delete: "Hapus",
			deleting: "Menghapus...",
			cancel: "Batal",
		},
	},
};

export default cardStockId;
